import { render, staticRenderFns } from "./DeviceMethodColumnInputs.vue?vue&type=template&id=52f2333c&scoped=true&"
import script from "./DeviceMethodColumnInputs.vue?vue&type=script&lang=js&"
export * from "./DeviceMethodColumnInputs.vue?vue&type=script&lang=js&"
import style0 from "./DeviceMethodColumnInputs.vue?vue&type=style&index=0&id=52f2333c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f2333c",
  null
  
)

export default component.exports